export const SERVER_ENDPOINT = process.env.REACT_APP_SERVER_ENDPOINT ?? "http://localhost:2602"
export const GRAPHQL_SERVER_ENDPOINT = process.env.REACT_APP_GRAPHQL_SERVER_ENDPOINT ?? `${SERVER_ENDPOINT}/graphql`
export const GRAPHQL_WS_SERVER_ENDPOINT = process.env.REACT_APP_GRAPHQL_WS_SERVER_ENDPOINT ?? "ws://localhost:2602/graphql"
